import React from 'react';
import PropTypes from 'prop-types';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import {
  UpdateHeader,
  UpdateTitle,
  UpdateVersion,
  UpdateDescription,
  StyledLink,
} from './styles';
import messages from './messages';

TimeAgo.locale(en);

const timeAgo = new TimeAgo('en-US');
const getElapsedTime = (date) => timeAgo.format(new Date(date));

const PluginDetailsUpdateSection = ({ version, pluginId, releaseDate, description }) => (
  <div>
    <UpdateHeader>
      <UpdateTitle>
        {intl.formatMessage(messages.whatsNewTitle)}
        { version &&
          <UpdateVersion>
            {intl.formatMessage(messages.version)} {version}{releaseDate && ` - ${getElapsedTime(releaseDate)}`}
          </UpdateVersion>
        }
      </UpdateTitle>
      <StyledLink to={`/plugins/${pluginId}/versions`}>{intl.formatMessage(messages.versionHistoryLink)}</StyledLink>
    </UpdateHeader>
    <UpdateDescription>
      {description}
    </UpdateDescription>
  </div>
);

PluginDetailsUpdateSection.propTypes = {
  version: PropTypes.string,
  pluginId: PropTypes.string,
  releaseDate: PropTypes.string,
  description: PropTypes.string,
};

export default PluginDetailsUpdateSection;
